import React from "react";
import { Phones } from "./Fields";
import MultiForm from "./MultipleForm";

export const AddPhone = () => {
  const addNewItem = React.useCallback((key) => {
    const fields = Phones(key);

    return { id: key, fields };
  }, []);

  return <MultiForm heading="phone" addNewItem={addNewItem} />;
};
